import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './crown-upsell-badge.module.scss';

interface CrownUpsellBadgeProps {
  className?: string;
}

export function CrownUpsellBadge({className = ''}: CrownUpsellBadgeProps): ReactElement {
  return (
    <div className={`flexbox flex-center radius-round ${styles.badge} ${className}`}>
      <Icon icon="icon-crown" size={IconSize.SIZE_ICON_16} className={styles.crown} />
    </div>
  );
}
